import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Block from '../Block';
import get from 'lodash/get';
import { Date } from '../Format';
import VersionBlock from './general/VersionBlock';
import ShowItem from "../ShowItem";
import HistoryEnabled from './general/HistoryEnabled';
import HistoryLocationStatus from './general/HistoryLocationStatus';
import HistoryLocationAuthorization from './general/HistoryLocationAuthorization';
import HistorySptConsent from './general/HistorySptConsent';
import HistoryMediaConsent from './general/HistoryMediaConsent';
import HistoryDataConsent from './general/HistoryDataConsent';


const WideLabelShowItem = (props) => {
  const wideLabels = {
    sm: 6,
    md: 6,
    lg: 6,
    xl: 6
  }

  return <ShowItem {...wideLabels} {...props}/>
}


const AdminGeneralDevice = ({device}) => {
  const { t } = useTranslation();

  return (
    <>
      <Block title={t("devices.general")}>
        <Row>
          <Col>
            <WideLabelShowItem label={t("devices.id")} value={device.id} />
            <WideLabelShowItem label={t("devices.idfa")} value={device.idfa} />
            <WideLabelShowItem label={t("devices.app")} value={get(device, 'app.name', '-')} />
            <WideLabelShowItem label={t("devices.active")} value={JSON.stringify(device.active)} />
            <WideLabelShowItem label={t("devices.enable")} value={JSON.stringify(device.enable)} />
            <WideLabelShowItem
              label={t("devices.createdAt")}
              value={<Date date={device.created_at} dateFormat='long' defaultValue='-'/>}
            />
            <WideLabelShowItem
              label={t("devices.updatedAt")}
              value={<Date date={device.updated_at} dateFormat='long' defaultValue='-'/>}
            />
            <WideLabelShowItem
              label={t("devices.InactivatedAt")}
              value={<Date date={device.inactivated_at} dateFormat='long' defaultValue='-'/>}
            />
            <WideLabelShowItem
              label={t("devices.lastRequest")}
              value={<Date date={device.last_request_at} dateFormat='long' defaultValue='-'/>}
            />
            <WideLabelShowItem label={t("devices.appVersion")} value={device.app_version} />
            <WideLabelShowItem label={t("devices.sdkVersion")} value={device.sdk_version} />
          </Col>
          <Col>
            <WideLabelShowItem label={t("devices.locationStatus")} value={device.location_status} />
            <WideLabelShowItem label={t("devices.locationAutorized")} value={JSON.stringify(device.location_aurhorized)} />
            <WideLabelShowItem label={t("devices.locationMode")} value={device.location_mode} />
            <WideLabelShowItem label={t("devices.deviceModel")} value={device.device_model} />
            <WideLabelShowItem label={t("devices.systemVersion")} value={device.system_version} />
            <WideLabelShowItem label={t("devices.lang")} value={device.lang} />
            <WideLabelShowItem label={t("devices.backgroundLocationEnabled")} value={JSON.stringify(device.background_location_enabled)} />
            <WideLabelShowItem label={t("devices.adTracking")} value={device.ad_tracking} />
            <WideLabelShowItem label={t("devices.cmp")} value={get(device, 'cmp.name', '-')} />
            <WideLabelShowItem label={t("devices.isCmp")} value={JSON.stringify(device.isCmp)} />
            <WideLabelShowItem label={t("devices.cmpMode")} value={device.isCmp} />
            <WideLabelShowItem label={t("devices.sptVendorConsent")} value={device.spt_consent} />
            <WideLabelShowItem label={t("devices.geomediaConsent")} value={device.media_consent} />
            <WideLabelShowItem label={t("devices.geoDataConsent")} value={device.data_consent} />
          </Col>
        </Row>
        <ShowItem label={t("devices.iabConsentString")} size={12} value={device.iab_consent_string} />
      </Block>
      <Row>
        <Col>
          <HistoryEnabled device={device}/>
        </Col>
        <Col>
          <HistoryLocationStatus device={device}/>
        </Col>
        <Col>
          <HistoryLocationAuthorization device={device}/>
        </Col>
      </Row>
      <Row>
        <Col>
          <HistorySptConsent device={device}/>
        </Col>
        <Col>
          <HistoryMediaConsent device={device}/>
        </Col>
        <Col>
          <HistoryDataConsent device={device}/>
       </Col>
      </Row>
      <Row>
        <Col>
          <VersionBlock data={device.versions}/>
        </Col>
     </Row>
    </>
  )
}

export default AdminGeneralDevice
